import React, { Component } from 'react';
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { formatText } = require('core/i18n').i18n;
const TabbedBoxLabel = require('components/commons/tabbedBox/tabbedBoxLabel/tabbedBoxLabel');
const { recordLinkCommonV2 } = require('commonsUtilities/tagging');
const { Button } = require('commonsComponents/button');
const { closed: glossaryClosed, opened: glossaryOpened } = require('actions/glossary');
const { switched: tabSwitched } = require('../../actions/tabs');
require('./TabSelector.scss');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const { FUND_GLOSSARY } = require('constants/flagBasedFeatures');
const {
    getProfitabilityData,
} = require('../../selectors/fundDataSelectors');
const { PRODUCTION_ENVIRONMENT } = require('constants/index');


class TabSelector extends Component {
    constructor(props) {
        super(props);
        this.tabMatchMedia = window.matchMedia("(max-width: 768px)");
        this.state = {
            widthLine: 227, // need to improve
            leftLine: 34, // need to improve
            barResponsive: '',
            isMobile: false,
            lastPositionTab: 0,
            navbarResponsive: '',
        };
        this.handleUpdate = this.handleUpdate.bind(this);
    }

    componentWillUnmount = () => {
        this.tabMatchMedia.removeListener(this.handleUpdate);
    };

    componentDidMount = () => {
        const { fund, profitabilityData } = this.props;
        const renderFeesTab = !!fund && ((!!fund.purchaseDetails && !!fund.purchaseDetails[0] && !!fund.purchaseDetails[0].frontLoad) || !!fund.administratorCompany  || fund.minimumDetails || fund.mifid);
        const isNotProduction = __ENVIRONMENT__ !== PRODUCTION_ENVIRONMENT;
        if (!profitabilityData && !renderFeesTab) {
            this.setState({
                leftLine: 301,
            });
        }
        if (!profitabilityData || !renderFeesTab) {
            this.setState({
                leftLine: 168,
            });
        }
        this.handleUpdate({matches:this.tabMatchMedia.matches});
        this.tabMatchMedia.addListener(this.handleUpdate);
        recordLinkCommonV2({
            categoriaEvento: 'broker/fund',
            accionEvento: 'funds tab',
            etiquetaEvento: formatText('fundsCard-infoTitle'),
        }, isNotProduction);
    };

    updateSizes = (widthLine, leftLine, barResponsive ) => Object.assign({}, {widthLine, leftLine,barResponsive})

    handleUpdate ({matches}) {
        let sizes;
        let isMobile = false;
        let navbarResponsive = '';
        if (matches) {
            sizes = this.updateSizes(185, 14 ,'bar--mobile');
            isMobile =  true;
            navbarResponsive = 'navbar__funds--mobile';
        } else {
            sizes = this.updateSizes(227, 34 , '');
        }
        this.setState({ widthLine: sizes.widthLine, leftline: sizes.leftLine , barResponsive: sizes.barResponsive , isMobile: isMobile , navbarResponsive: navbarResponsive });
    }

    switchTabPosition = (i, width, left, elem) => {
        const tagEventsByElement = {
            [formatText('fundsCard-infoTitle')]: 'generalInformation',
            [formatText('fundsCard-assetsTitle')]: 'assetDistribution',
            [formatText('fundsCard-profitabilityTitle')]: 'profitability',
            [formatText('fundsCard-feesTitle')]: 'commissionsAndManagement'
        }
        let selectedTabOffset = this.scrollableMenu.children[i].offsetLeft;
        const offsetForward = 5;
        const offsetBack = 40;

        if(i >= this.state.lastPositionTab){
            this.scrollableMenu.scrollLeft = (selectedTabOffset  + offsetForward);
        }
        else {
            this.scrollableMenu.scrollLeft = (selectedTabOffset  - offsetBack);
        }

        this.setState({
            widthLine: width,
            leftLine: left,
            lastPositionTab: i,
        });


        this.props.switchTab(i);
        const isNotProduction = __ENVIRONMENT__ !== PRODUCTION_ENVIRONMENT;
        tagEventsByElement[elem] && recordLinkCommonV2({
            categoriaEvento: 'fundDescriptionInteraction',
            accionEvento: 'evolution',
            etiquetaEvento: tagEventsByElement[elem],
            action: 'click',
            format: 'tab',
            component: 'body',
            element: tagEventsByElement[elem],
            eventCategory: 'fundDescriptionInteraction',
            eventAction: 'clickTab',
            eventLabel: tagEventsByElement[elem],
        }, isNotProduction);
    }


    render () {
        const { widthLine, leftLine , isMobile, navbarResponsive } = this.state;
        const { closeGlossary, glossaryOpen, openGlossary, selectedTab, profitabilityData, fund} = this.props;
        let TAB_NAMES= [
            formatText('fundsCard-infoTitle'),
            formatText('fundsCard-assetsTitle'),
        ]
        const isNotProduction = __ENVIRONMENT__ !== PRODUCTION_ENVIRONMENT;
        if (!!profitabilityData) {
            TAB_NAMES.push(formatText('fundsCard-profitabilityTitle'));
        }
        if(!!fund && ((!!fund.purchaseDetails && !!fund.purchaseDetails[0] && !!fund.purchaseDetails[0].frontLoad) || !!fund.administratorCompany  || fund.minimumDetails || fund.mifid)) {
            TAB_NAMES.push(formatText('fundsCard-feesTitle'));
        }
        return (
            <nav className="navbar navbar--funds">
            <div className={`navbar__funds ${navbarResponsive}`}>
                <ul className="no--scrollbar" ref={scrollableMenu => this.scrollableMenu = scrollableMenu}>
                    {
                        TAB_NAMES.map((elem, i) => (
                            <TabbedBoxLabel
                                key={i}
                                index={i}
                                label={elem}
                                active={selectedTab === i}
                                onTabSelection={(i, width, left) => this.switchTabPosition(i, width, left, elem)}
                                id={elem}
                                getContextData={true}
                            />
                        ))
                    }
                    {!isMobile &&
                        <div className="bar" style={{
                        left: `${leftLine}px`,
                        width: `${widthLine}px`
                        }}>{}</div>
                    }
                </ul>
            </div>
                <FeatureTogglingRender notAllowedProductKey={FUND_GLOSSARY}>
                <div className="navbar__funds__glossary-button">
                    <Button
                        iconClass="icon-glosario"
                        onClick={() => {
                            recordLinkCommonV2({
                                categoriaEvento: 'fundDescriptionInteraction',
                                accionEvento: 'evolution',
                                etiquetaEvento: 'glossary'
                            }, isNotProduction);
                            glossaryOpen ? closeGlossary() : openGlossary();
                        }}
                    >
                        {formatText('glossary-title')}
                    </Button>
                </div>
            </FeatureTogglingRender>
        </nav>
        )
    }
}


TabSelector.propTypes = {
    closeGlossary: PropTypes.func.isRequired,
    fund: PropTypes.object.isRequired,
    glossaryOpen: PropTypes.bool.isRequired,
    openGlossary: PropTypes.func.isRequired,
    profitabilityData: PropTypes.array,
    selectedTab: PropTypes.number.isRequired,
    switchTab: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => ({
    glossaryOpen: state.glossary.isOpen,
    selectedTab: state.brokerInvestmentFundView.selectedTab,
    profitabilityData: getProfitabilityData(state, props),
});

const mapDispatchToProps = dispatch => ({
    closeGlossary: () => dispatch(glossaryClosed()),
    openGlossary: query => dispatch(glossaryOpened({ query })),
    switchTab: index => dispatch(tabSwitched({ index })),
});


module.exports = connect(mapStateToProps, mapDispatchToProps)(TabSelector);
